import httpClient from '~utils/httpClient';
import { API_ENDPOINTS } from '~modules/Auth/constants';

export function getRoles(applicationId) {
  return httpClient({
    method: 'get',
    url: `${API_ENDPOINTS.roles}/${applicationId}`,
    baseURL: '/',
  });
}

export function createRole(data) {
  return httpClient({
    method: 'post',
    url: `${API_ENDPOINTS.createRole}?applicationId=${data.applicationId}`,
    baseURL: '/',
    data,
  });
}

export function updateRole(data) {
  return httpClient({
    method: 'patch',
    url: `${API_ENDPOINTS.role}/${data.roleId}`,
    baseURL: '/',
    data
  });
}

export function deleteRole({roleId}) {
  return httpClient({
    method: 'delete',
    url: `${API_ENDPOINTS.role}/${roleId}`,
    baseURL: '/'
  });
}

export function assignRole(data) {
  return httpClient({
    method: 'post',
    url: `${API_ENDPOINTS.assignRole}`,
    baseURL: '/',
    data
  });
}

export function assignRoleBulk(data) {
  return httpClient({
    method: 'post',
    url: `${API_ENDPOINTS.assignRoleBulk}`,
    baseURL: '/',
    data
  });
}

export function unAssignRole(data) {
  return httpClient({
    method: 'post',
    url: `${API_ENDPOINTS.unAssignRole}`,
    baseURL: '/',
    data
  });
}

export function getSubjects(data) {
  return httpClient({
    method: 'get',
    url: `${API_ENDPOINTS.subjects}`,
    baseURL: '/',
    data
  });
}

export function getApplicationRoles(any) {
  const url = any ? API_ENDPOINTS.applicationRoles : API_ENDPOINTS.applicationRolesForCustomer;
  return httpClient({
    method: 'get',
    url,
    baseURL: '/',
  });
}

export function getUserPermissions() {
  return httpClient({
    method: 'get',
    url: '/api/authorization',
    baseURL: '/',
  });
}

export function synchronizeRole(role) {
  return httpClient({
    method: 'post',
    url: API_ENDPOINTS.synchronizeRole,
    baseURL: '/',
    data: role
  });
}

export function getRolesForSync({applicationName}) {
  return httpClient({
    method: 'get',
    url: `${API_ENDPOINTS.rolesForSync}/${applicationName}`,
    baseURL: '/',
  });
}

export function duplicateRole(roleId) {
  return httpClient({
    method: 'post',
    url: `${API_ENDPOINTS.duplicateRole}/${roleId}`,
    baseURL: '/',
    data: {}
  });
}